/**
 * Event constants for EventBus communication between modules
 */

export const EVENTS = {
  // Search
  SEARCH_START: 'search:start',
  SEARCH_RESULTS: 'search:results',
  SEARCH_ERROR: 'search:error',

  // Suggestions
  SUGGEST_RESULTS: 'suggest:results',
  SUGGEST_SELECT: 'suggest:select',

  // Filters
  FILTER_CHANGE: 'filter:change',
  FILTER_RESET: 'filter:reset',

  // Panel
  PANEL_OPEN: 'panel:open',
  PANEL_CLOSE: 'panel:close',

  // Crop (visual search)
  CROP_START: 'crop:start',
  CROP_COMPLETE: 'crop:complete',
  CROP_CANCEL: 'crop:cancel',

  // Photo upload
  PHOTO_UPLOAD: 'photo:upload',
};
